import { Component } from "@angular/core";
import { ExportBase } from "../export-base";
import { ExportType } from "@enums/ExportType";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "export-datamanagement",
    templateUrl: "./export-datamanagement.component.html",
    styleUrls: ["./export-datamanagement.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, FormsModule, MatCheckboxModule]
})
export class ExportDatamanagementComponent extends ExportBase {
    includeChecked = false;

    downloadDatamanagement(type: ExportType) {
        const extra = `includedeletedandclosedmois=${this.includeChecked}`;
        this.exportDataService.downloadExport(type, extra);
    }
}
